import gql from 'graphql-tag';

export const NAME = 'compositions_StoreNoteForm_updateDealerNotesMutation';

const query = gql`
  mutation ${NAME} ($notes: String, $id: ID!) {
    updateDealer(
      input: {
        id: $id,
        patch: {
          notes: $notes
        },
      },
    ) {
      dealer { notes }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Notes/withUpdateDealerNotes/updateDealerNotesMutation.js